import React, { useContext, useState } from 'react'
import { VehicleContext } from '../Context/VehicleContext';
import ReCAPTCHA from 'react-google-recaptcha';
import { useNavigate } from 'react-router-dom';

const JoinMailing = () => {
    const navigate = useNavigate();
    const {submitContactForm} = useContext(VehicleContext);
    const recaptchaRef = React.useRef();

    const [email, setEmail] = useState('');
  const [error, setError] = useState('');

  const validateEmail = (email) => {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(email);
  };

    const handleSubmit = async () => {
        if (!email) {
            setError('Email is required');
        } else if (!validateEmail(email)) {
            setError('Please enter a valid email address');
        } else {
            setError('');
            console.log('Submitted Email:', email);
            const token = await recaptchaRef.current.executeAsync();
            recaptchaRef.current.reset(); // Reset after use

            var values = {"token":token,"email":email};

            console.log(values);
            const data = await submitContactForm(values);
            if (data.success) {
                setEmail('');
                navigate("/thank-you");
                // alert("Thank you for your submission. We'll be in touch soon!");
            } else
                alert("There was a problem with your submission");
        }
    };
    return (
        <>
            <section className='mailing-list-wrap'>
                <div className='container'>
                    <div className='text-center'>
                        <div className='d-md-inline-flex align-items-center mailing-list-block'>
                            <h2 className='main-title text-uppercase fw-300 text-lgray mr-90 pt-2'>Join Our Mailing List</h2>
                            <div className='text-start'>
                                <div className='d-inline-flex align-items-center mlb-flex'>
                                    <ReCAPTCHA
                                        ref={recaptchaRef}
                                        sitekey="6Ld25IorAAAAANZCaPfhdftOf511aOBscsnhKulz" // Replace with your actual site key
                                        size="invisible"
                                    />
                                    <input
                                        type='text'
                                        className='form-control'
                                        placeholder='Enter Email'
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                    <button
                                        type='button'
                                        className='theme-btn text-uppercase d-inline-block'
                                        onClick={handleSubmit}
                                    >
                                        Join Now
                                    </button>
                                </div>
                                {error && <div className='mt-2'><small className="text-danger mb-2">{error}</small></div>}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default JoinMailing